import { Controller } from "stimulus";
import Dropzone from "dropzone";
import { overrideDropzoneCancel, createDirectUploadController, removeElement, removeBlob, findElement } from '../../dropzone/media_helper';

export const createDropZone = function(controller) {
  return new Dropzone(controller.element, {
    url: controller.url,
    maxFiles: controller.maxFiles,
    acceptedFiles: controller.acceptedFiles,
    addRemoveLinks: controller.addRemoveLinks,
    autoQueue: false,
    queuecomplete: function() {
      $('.save-btn').prop('disabled', false)
    }
  });
}

export default class extends Controller {
  static targets = ["input"];

  connect() {
    overrideDropzoneCancel();
    this.dropZone = createDropZone(this);
    this.hideFileInput();
    this.bindEvents();
    Dropzone.autoDiscover = false;
  }

  get url() {
    return this.inputTarget.getAttribute("data-direct-upload-url");
  }

  get maxFiles() {
    return 1;
  }

  get acceptedFiles() {
    return this.data.get("extensions");
  }

  get inputName() {
    return this.data.get("inputName");
  }

  get addRemoveLinks() {
    return this.data.get("addRemoveLinks") || true;
  }

  hideFileInput() {
    this.inputTarget.disabled = true;
    this.inputTarget.style.display = "none";
  }

  bindEvents() {
    this.dropZone.on("addedfile", file => {
      setTimeout(() => {
        file.accepted && createDirectUploadController(this, file, this.inputName).start();
      }, 500);

      if (this.dropZone.element.dataset.name === 'policyDropzone') {
        hideModalClasses();
        $('#policyModal').modal('show')
        const formDropzone = $('#policyModal').find('.dropzone')[0].dropzone
        formDropzone.removeAllFiles(true);
        this.dropZone.removeFile(file);
        formDropzone.addFile(file);
      }
    });

    this.dropZone.on("removedfile", file => {
      if (file.controller) {
        let element = file.controller.hiddenInput;
        removeElement(element);
        removeBlob(element.value);
        $('.save-btn').prop('disabled', true)
      }
    });

    this.dropZone.on("canceled", file => {
      file.controller && file.controller.xhr.abort();
    });
  }
}
